import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { ChangableComponent } from '@models/changable.component';
import { ErrorNotificationService } from '@shared/error-notification/error-notification.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { OnUiCover } from 'onclass-ui';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainHeaderComponent extends ChangableComponent implements OnInit {
  public background = '';
  public title = '';
  public cover: OnUiCover;
  constructor(
    public errorNotificationService: ErrorNotificationService,
    private router: Router,
    public deviceService: DeviceDetectorService,
    protected cdr: ChangeDetectorRef,
  ) {
    super(cdr);
  }

  ngOnInit() {
    this.router.events
      .pipe(
        filter((e) => e instanceof NavigationEnd),
        takeUntil(this.destroyed$),
      )
      .subscribe({
        next: (event) => {
          const routerEvent = event as RouterEvent;
          this.setBackground(routerEvent.url);
          this.detectChanges();
        },
        error: (error) => {
          this.errorNotificationService.captureError(error, 'OTHER-PROBLEM');
        }
      });

    this.setBackground(this.router.url);
  }

  private findItemUrl(url: string, position = 1): string {
    const isFound = !![this.router.url.split('/')[position]].find((substr) => substr?.includes(url));
    return isFound ? this.router.url : '';
  }

  private setBackground(url: string) {
    switch (url) {
      case this.findItemUrl('schedule'):
        this.background = 'schedule-header';
        this.title = 'header-titles.schedule';
        break;
      case this.findItemUrl('users'):
        this.background = 'users-header';
        this.title = 'users.tabs-subscriptions';
        break;
      case this.findItemUrl('my-feed'):
        this.background = 'feed-header';
        this.title = 'menu.left-sidebar.my-feed';
        break;
      case this.findItemUrl('settings', 2):
      case '/me/settings':
        this.background = 'settings-header';
        this.title = 'sidebar-options.settings';
        break;
      case this.findItemUrl('finance', 2):
      case '/me/finance':
        this.background = 'finance-header';
        this.title = 'finance.title';
        break;
      case this.findItemUrl('main'):
        this.background = 'main';
        this.title = 'OnClass';
        break;
      case this.findItemUrl('my-classes'):
        this.background = 'my-classes';
        this.title = 'my-classes.page-header-title';
        break;
      case this.findItemUrl('my-library'):
        this.background = 'my-library';
        this.title = 'my-library.page-header-title';
        break;
      case this.findItemUrl('favorites'):
        this.background = 'favorites';
        this.title = 'favorites.page-header-title';
        break;
      case this.findItemUrl('my-vocabulary'):
        this.background = 'vocabulary';
        this.title = 'my-vocabulary.page-header-title';
        break;
      default:
        this.background = '';
        this.title = '';
    }

    this.cover = {
      type: 'cover',
      img: this.assetsUrl(
        `/assets/images/headers/${this.background + (this.deviceService.isMobile() ? '-mobile' : '')}.jpg`,
      ),
      form: this.deviceService.isMobile() ? 'none' : 'base',
    };
  }
}
